const constants = {
  exam_groups: ["Science", "Arts", "Commerce"],
  exam_names: [
    "SSC",
    "HSC",
    "Bachelor",
    "Diploma",
    "Masters",
    "O level",
    "A level",
  ],
  exam_boards: [
    "Barisal",
    "Chittagong",
    "Comilla",
    "Dhaka",
    "Jessore",
    "Mymensingh",
    "Rajshahi",
    "Dinajpur",
    "Sylhet",
    "Madrasah Board",
    "Technical Board",
  ],
  grades: [
    {
      id: 1,
      name: "A",
    },
    {
      id: 2,
      name: "B",
    },
    {
      id: 3,
      name: "C",
    },
    {
      id: 4,
      name: "D",
    },
    {
      id: 5,
      name: "E",
    },
  ],
  education_fields: [
    {
      name: "SSC",
      board: "",
      group: "",
      gpa: "",
      passing_year: null,
    },
    {
      name: "HSC",
      board: "",
      group: "",
      gpa: "",
      passing_year: null,
    },
    {
      name: "Bachelor",
      university_id: "",
      subject_id: "",
      gpa: "",
      passing_year: null,
    },
    {
      name: "Master",
      university_id: "",
      subject_id: "",
      gpa: "",
      passing_year: null,
    },
    {
      name: "Diploma",
      group: "",
      subject_id: "",
      board: "",
      gpa: "",
      passing_year: null,
      institute_id: "",
    },
    {
      name: "O Level",
      institute_id: "",
      grade: "",
      passing_year: null,
    },
    {
      name: "A Level",
      institute_id: "",
      grade: "",
      passing_year: null,
    },
  ],
  customer_status: [
    {
      id: "Active",
      label: "Active",
      color: "#0db30d",
    },
    {
      id: "Inactive",
      label: "Inactive",
      color: "#ff564a",
    },
    {
      id: "New",
      label: "New",
      color: "#3498db",
    },
    {
      id: "IN_PROGRESS",
      label: "In Progress",
      color: "#f39c12",
    },
    {
      id: "HOLD",
      label: "Hold",
      color: "#95a5a6",
    },
    // {
    //   id: "Attendance_Lead",
    //   label: "Attendance/Lead",
    //   color: "#9b59b6",
    // },
    // {
    //   id: "Project",
    //   label: "Project",
    //   color: "#2ecc71",
    // },
    // {
    //   id: "Invoice_Expense",
    //   label: "Invoice/Expense",
    //   color: "#e74c3c",
    // },
  ],

  leaveStatus: [
    {
      id: "approved",
      label: "Approved",
      color: "#29CC39",
    },
    {
      id: "rejected",
      label: "Rejected",
      color: "#FF6633",
    },
    {
      id: "pending",
      label: "Pending",
      color: "#FFA500",
    },
  ],

  invoiceStatuses: [
    {
      id: "paid",
      name: "Paid",
      color: "#29CC39", // blue
    },
    {
      id: "unpaid",
      name: "Unpaid",
      color: "#ff564a", // red
    },
    {
      id: "hold",
      name: "Hold",
      color: "#ffc107", // yellow
    },
    {
      id: "partial",
      name: "Partial",
      color: "#ff9800", // orange
    },
    {
      id: "inactive",
      name: "Inactive",
      color: "#888", // gray
    },
  ],
};

export const {
  exam_groups,
  exam_names,
  exam_boards,
  grades,
  education_fields,
  customer_status,
  leaveStatus,
  invoiceStatuses,
} = constants;
